
























import XCircle from 'vux/src/components/x-circle/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'


export default {
props: ['status', 'gap'],
components: {
XCircle,
Spinner,
},
data() {
return {};
},
computed: {
percent() {
const per = -this.gap / 0.6;

return Math.max(0, Math.min(per, 100));
},
angle() {
return this.percent / 200 * 360;
},
scale() {
const scale = 0.5 + this.percent / 200;
return scale > 1 ? 1 : scale;
},
},
mounted() {
this.initPoint();
},
methods: {
initPoint() {},
},
};
